import { Logout } from "@mui/icons-material";
import {
    Avatar,
    Divider,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    Tooltip
} from "@mui/material";
import Cookies from "js-cookie";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logUserOut } from "services/redux/site";
import { AppDispatch, RootState } from "services/redux/store";

const AccountDropDown = () => {
    const mode = useSelector((state: RootState) => state.site.mode);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const dispatch = useDispatch<AppDispatch>();

    const logout = () => {
        setAnchorEl(null);
        Cookies.set("logedIn", "false", { expires: 365 });
        dispatch(logUserOut());
    };

    return (
        <div>
            <Tooltip title="Account">
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    style={{ marginLeft: 0 }}
                >
                    <Avatar />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1
                        },
                        "&::before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0
                        }
                    }
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                className={`${mode == "dark" ? "is-dark" : ""}`}
            >
                <MenuItem onClick={handleClose}>
                    <Avatar />
                    <div className="flex text-sm flex-col justify-start items-start">
                        <span>full Name</span>
                        <span>@userName</span>
                    </div>
                </MenuItem>
                <Divider />
                <MenuItem onClick={logout}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    <span className="text-sm">Logout</span>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default AccountDropDown;
